import PageContainer from "../../components/PageContainer";
import { Text } from "@mantine/core";

const Statistics = () => {
    return (
        <PageContainer>
            <Text mt={0} mb={30} size={'xl'}>Статистика</Text>
        </PageContainer>
    );
};
export default Statistics;
